/**
 * global "buyers_guide_text" set on /assets/wp_footer.php
 * global "sellers_guide_text" set on /assets/wp_footer.php
 * global "on_site_shifts_text" set on /assets/wp_footer.php
 *
*/

/*
function mockForm() {
  const cf7Form = document.querySelector('.wpcf7-form');

  if (cf7Form.classList.contains('on-site-shifts')) {
    cf7Form.querySelector('#first_name').value = 'Miguel';
    cf7Form.querySelector('#last_name').value = 'Garrido';
    cf7Form.querySelector('#contact_email').value = 'teledirigido@gmail.com';
    cf7Form.querySelector('#contact_phone').value = '611070568';
    cf7Form.querySelector('#contact_region').value = 'Auckland';
    cf7Form.querySelector('#contact_how_did_you_hear_about_us').value = 'Trade Me';
  }

}

mockForm();
*/

const cf7MailSent = {
  
  setForm(lightboxText) {
    const lightbox = document.querySelector('#lightbox-cf7mailsent');
    const titleTag = lightbox.querySelector('.lightbox-title');
    const descriptionTag = lightbox.querySelector('.lightbox-description');
    const linkTag = lightbox.querySelector('.lightbox-link');
    
    if (titleTag) {
      titleTag.textContent = lightboxText.title;
    }

    if (descriptionTag) {
      descriptionTag.innerHTML = lightboxText.description;
    }

    if (linkTag) {
      linkTag.href = lightboxText.link;
    }
    document.querySelector('.lightbox-cf7mailsent-trigger').click();
  }

}


document.addEventListener( 'wpcf7mailsent', function( event ) {

  const cf7Form = document.querySelector('.wpcf7-form');

  if (cf7Form.classList.contains('buyers-guide') && buyers_guide_text) {
    cf7MailSent.setForm(buyers_guide_text);
  }

  if (cf7Form.classList.contains('sellers-guide') && sellers_guide_text) {
    cf7MailSent.setForm(sellers_guide_text);
  }

  if (cf7Form.classList.contains('on-site-shifts') && on_site_shifts_text) {
    cf7MailSent.setForm(on_site_shifts_text);
  }

}, false );
